import { useNavigate } from "react-router-dom";
import { useAuth } from "../AuthProvider";
import { useEffect, useState } from "react";
import Loader from "./Loader";

const AuthWrapper = ({ children }) => {
  const { user, loading } = useAuth();
  const navigate = useNavigate();
  const [showLoader, setShowLoader] = useState(true);
  const [fadeOut, setFadeOut] = useState(false);

  // Exibe o loader nos primeiros segundos
  useEffect(() => {
    const delay = setTimeout(() => {
      setFadeOut(true); // inicia animação de fade-out
      setTimeout(() => setShowLoader(false), 500); // remove após animação
    }, 2500);

    return () => clearTimeout(delay);
  }, []);

  useEffect(() => {
    if (loading || showLoader) {
      return; // Não faz nada enquanto estiver carregando
    }
    
    // Se não há usuário, verificamos se a rota é pública
    if (!user) {
      const { pathname } = window.location;
      
      // Lista de rotas públicas exatas
      const publicRoutes = [
        "/login",
        "/forgot-password",
        "/register",
        "/register/user",
        "/register/carrier",
        "/register/driver",
        "/remote-signature",
        "/accept-invite",
      ];
      
      // Verifica se a rota atual é uma das rotas públicas exatas OU se começa com /reset-password/
      const isPublic = publicRoutes.includes(pathname)
                       || pathname.startsWith('/reset-password/')
                        || pathname.startsWith('/loads/public/')
                         || pathname.startsWith('/inspectiongallery/')
                          || pathname.startsWith('/company/public/')
                            || pathname.startsWith('/remote-signature/');

      // Se NÃO for uma rota pública, redireciona para o login
      if (!isPublic) {
        navigate("/login");
      }
    }
  }, [user, loading, showLoader, navigate]);

  if (loading || showLoader) {
    return <Loader fadeOut={fadeOut} />;
  }

  return children;
};

export default AuthWrapper;